import React from 'react';

export const HOME_PAGE_VIEW_V4: string = 'homePageV4ViewV2';
export const SERVICE_NAME: string = 'user.service';
export const USER_NAME: string = 'userName';
export const MAX_ALLOWED_ID: number = 100000;

export enum EButtonText {
	SAVE = 'Save',
	SAVED = 'Saved'
}

export interface IHomePageZkData<T> {
	keyName: string;
	serviceName: string;
	agent: string;
	desc: string;
	data: T;
	game: string;
}

export enum EHomePageViewType {
	EXISTING_USER = 'existingUser',
	NEW_USER = 'newUser',
	SEGMENT_BASED_USER = 'segmentBasedUser',
	AB_TEST_BASED_USER = 'abTestBasedUser'
}

export enum EHomePageViewTranslatedCategory {
	NON_SEGMENT_VIEW = 'nonSegmentView',
	SEGMENT_VIEW = 'segmentView'
}

export interface ISegmentBasedUser {
	segment: string;
	view: string[][];
}

export interface INewUser {
	A: string[][];
	B: string[][];
}

export interface IAbTestBasedUser {
	newUser: INewUser;
}

export interface IHomePageV4View {
	existingUser: string[][];
	newUser: string[][];
	segmentBasedUser: ISegmentBasedUser[];
	abTestBasedUser: IAbTestBasedUser;
}

export interface IHomePageTranslatedKeys {
	segmentView: string[];
	nonSegmentView: string[];
}

export type ITObject<T> = {
	[key: string]: T;
};

export interface IHomePageModifiedData {
	viewKeys: IHomePageTranslatedKeys;
	segmentView: ITObject<string[][]>;
	nonSegmentView: ITObject<string[][]>;
}

export interface IViewInterface {
	viewType: string;
	viewKey: string;
	updatedHomePageView: IHomePageModifiedData;
	homePageView: IHomePageV4View;
	setUpdatedHomePageView: React.Dispatch<React.SetStateAction<IHomePageModifiedData>>;
}
